<div
  id="cac-sms-consent-div"
  class="divWhiteBackground"
  *ngIf="smsConsentContent"
>
  <div class="form-group desktop-97-5">
    <div id="cac-div-sms-termsAndConditions" class="cac-sms-consent">
      <label
        id="sms_termsAndConditions"
        class="sms-consent-inner"
        [innerHTML]="smsConsentContent | safeHtml"
      ></label>

      <div class="sms-consent-agree-label">
        <div class="cac-agreement-consent">
          <input
            type="checkbox"
            tabindex="0"
            aria-labelledby="sms_termsAndConditions"
            id="smsConsentAgreed"
            name="smsConsentAgreed"
            [formControl]="smsConsentAgreed"
          />
        </div>
        <div class="sms-consent-agree-label-txt">I Agree</div>
      </div>
    </div>
  </div>
</div>
